import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import updateUserConfigurationOperation from 'owa-service/lib/operation/updateUserConfigurationOperation';
import updateUserConfigurationOwaRequest from 'owa-service/lib/factory/updateUserConfigurationOwaRequest';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export var VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';
export var USER_OPTIONS_CONFIGURATION = 'OWA.UserOptions';
var USER_OPTIONS_BASEFOLDERID_NAME = 'root';
var UPDATE_FOLDER_VIEW_STATE_DELAY_MS = 10 * 1000;
var updateFolderViewStateTimer = null;
/**
 * Delay update the folder view state service
 * @param userConfiguration the user configuration
 */
export default function updateFolderViewStateService(userConfiguration) {
    var folderViewState = userConfiguration.ViewStateConfiguration.FolderViewState;
    if (folderViewState) {
        var serializedFolderViewState_1 = [];
        for (var i = 0; i < folderViewState.length; i++) {
            serializedFolderViewState_1.push(folderViewState[i]);
        }
        // Save this changes with a timer so we can batch all of them together.
        if (!updateFolderViewStateTimer) {
            updateFolderViewStateTimer = setTimeout(function () {
                // Clear the time handle.
                updateFolderViewStateTimer = null;
                // Make the call.
                updateUserConfigurationService(VIEW_STATE_CONFIGURATION, {
                    // Key
                    Type: 'String',
                    Value: ['FolderViewState'],
                }, {
                    // Value
                    Type: 'StringArray',
                    Value: serializedFolderViewState_1,
                });
            }, UPDATE_FOLDER_VIEW_STATE_DELAY_MS);
        }
    }
}
/**
 * Update the user configuration service internal
 * @param userConfigurationName the user configuration name
 * @param key the key which is the field to update
 * @param value the value of the field
 */
function updateUserConfigurationService(userConfigurationName, key, value) {
    var newUserConfiguration = serviceUserConfiguration({
        UserConfigurationName: userConfigurationNameType({
            Name: userConfigurationName,
            BaseFolderId: distinguishedFolderId({
                Id: USER_OPTIONS_BASEFOLDERID_NAME,
            }),
        }),
        Dictionary: [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject(key),
                DictionaryValue: userConfigurationDictionaryObject(value),
            }),
        ],
    });
    return updateUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: updateUserConfigurationOwaRequest({
            UserConfiguration: newUserConfiguration,
        }),
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=updateFolderViewStateService.js.map